import {
    serializable,
    DynamicFormControlLayout,
    DynamicInputModel,
    DynamicInputModelConfig,
} from "@ng-dynamic-forms/core";
import { Model_WorkflowComponent, Model_VariableEnvironnement } from 'src/app/app.models';

export class Model_InputGridColumnsDatasourceMappingComponent extends Model_WorkflowComponent {
    workflowComponents: Model_WorkflowComponent[];
    variablesEnvironnement: Model_VariableEnvironnement[];
}
  
export interface InputGridColumnsDatasourceMappingModelConfig extends DynamicInputModelConfig {
}
  
export class InputGridColumnsDatasourceMappingModel extends DynamicInputModel {
	@serializable() readonly type: string = 'input_grid_columns_datasource_mapping';
	constructor(config: InputGridColumnsDatasourceMappingModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
	}

	public static initModel(_component: Model_WorkflowComponent) {
		const formModel = new InputGridColumnsDatasourceMappingModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE !== undefined ? _component.IS_VISIBLE === false : false,
            relations: _component.RELATIONS,
			validators: _component.CUSTOM_VALIDATORS,
            additional: _component
		});
		return formModel;
	}
}
  